module.exports = __webpack_public_path__ + "media/se_show_result_value.b6cf99da.mp3";